export const HIDE_ZERO_BALANCES_KEY = 'STARBETS-HZB';
